import { useCallback } from "react"
import { createModel } from "hox"
import { useSetState } from "@/reactUse"

type Layer = Partial<{
  datasource_id: string
  name: string
  x: any[]
  y: any[]
  is_show: "boolean"
  show_type: "heat" | "grid_heat" | "point" | "trace" | "polygon_heat"
  trace_id: string
  datetime_id: string
  play_time_series: string[]
  geo: any[]
  field_filters: { field_id: string; op: string; value: any }[]
  date_field_id: string
}>

function useLayer() {
  const [state, set] = useSetState<{ layer: Layer }>({ layer: {} })

  const setLayer = useCallback(
    (layer: Layer) => {
      set({ layer })
    },
    [set]
  )
  return {
    ...state,
    setLayer,
  }
}

export default createModel(useLayer)
